function showActualEntryForm() {
    document.getElementById('actual-entry-form-container').style.display = 'block';
}

function hideActualEntryForm() {
    document.getElementById('actual-entry-form-container').style.display = 'none';
}

if (!window.jobCostDocPreviewOpen) {
    const buildPreviewUrl = function (previewUrl, previewTitle) {
        if (!previewUrl) return "";
        const isPdf = /\.pdf$/i.test(previewTitle || "");
        if (!isPdf) return previewUrl;

        const baseUrl = previewUrl.split("#")[0];
        return `${baseUrl}#page=1&zoom=page-width`;
    };

    window.jobCostDocPreviewOpen = function (trigger) {
        if (!trigger) return;

        const selector = trigger.getAttribute("data-bs-target");
        if (!selector) return;

        const modal = document.querySelector(selector);
        if (!modal) return;

        const iframe = modal.querySelector("[data-doc-preview-iframe]");
        const title = modal.querySelector("[data-doc-preview-title]");
        const previewUrl = trigger.getAttribute("data-doc-preview-url");
        const previewTitle = trigger.getAttribute("data-doc-preview-title") || "Document Preview";
        const iframeUrl = buildPreviewUrl(previewUrl, previewTitle);

        if (title) title.textContent = previewTitle;
        if (iframe) iframe.setAttribute("src", iframeUrl);
    };
}

if (!window.jobCostModalCleanup) {
    window.jobCostModalCleanup = function () {
        if (document.querySelector(".modal.show")) return;

        document.querySelectorAll(".modal-backdrop").forEach((backdrop) => backdrop.remove());
        document.body.classList.remove("modal-open");
        document.body.style.removeProperty("padding-right");
        document.body.style.removeProperty("overflow");
    };
}

if (!window.jobCostDocPreviewModalBound) {
    window.jobCostDocPreviewModalBound = true;
    document.addEventListener("hidden.bs.modal", function (event) {
        const modal = event.target;
        if (!modal || !modal.matches(".modal")) return;

        const iframe = modal.querySelector("[data-doc-preview-iframe]");
        const title = modal.querySelector("[data-doc-preview-title]");

        if (iframe) iframe.setAttribute("src", "");
        if (title) title.textContent = "Document Preview";
        window.jobCostModalCleanup();
    });
}

if (!window.jobCostUploadModalBound) {
    window.jobCostUploadModalBound = true;

    document.addEventListener("turbo:submit-start", function (event) {
        const form = event.target;
        if (!(form instanceof HTMLFormElement)) return;
        if (form.dataset.jobCostCloseModal !== "true") return;

        const modal = form.closest(".modal");
        if (!modal) return;

        if (window.bootstrap && window.bootstrap.Modal) {
            const instance = window.bootstrap.Modal.getInstance(modal) || window.bootstrap.Modal.getOrCreateInstance(modal);
            instance.hide();
        } else {
            modal.classList.remove("show");
            modal.style.display = "none";
        }

        setTimeout(window.jobCostModalCleanup, 120);
    });

    document.addEventListener("turbo:frame-load", function () {
        window.jobCostModalCleanup();
    });

    document.addEventListener("turbo:render", function () {
        window.jobCostModalCleanup();
    });
}

if (!window.jobCostSummaryActualInputSelectBound) {
    window.jobCostSummaryActualInputSelectBound = true;
    const actualInputSelector = ".js-job-cost-summary-actual-input";

    const selectAll = function (target) {
        if (!(target instanceof HTMLInputElement) && !(target instanceof HTMLTextAreaElement)) return;
        target.select();
    };

    document.addEventListener("focusin", function (event) {
        const target = event.target;
        if (!(target instanceof Element) || !target.matches(actualInputSelector)) return;

        requestAnimationFrame(function () {
            selectAll(target);
        });
    });

    document.addEventListener("click", function (event) {
        const target = event.target;
        if (!(target instanceof Element) || !target.matches(actualInputSelector)) return;
        selectAll(target);
    });
}
